import type { PricingSettings } from "@workspace/api-client-react";
import { finalPriceBDT } from "./pricing";
import type { Variant } from "./store";

export function getSalePricing(
  variant: Variant,
  pricing: PricingSettings,
  minSaleDiscountPercent = 1,
) {
  const salePriceBDT = variant.priceBDT ?? finalPriceBDT(variant.price, pricing);
  const originalPriceBDT = typeof variant.compareAtPriceBDT === "number"
    ? variant.compareAtPriceBDT
    : variant.compareAtPricePKR != null
      ? finalPriceBDT(variant.compareAtPricePKR, pricing)
      : null;
  const discountPercent = originalPriceBDT !== null
    && originalPriceBDT > salePriceBDT
    && originalPriceBDT > 0
    ? Math.round((originalPriceBDT - salePriceBDT) / originalPriceBDT * 100)
    : 0;
  const hasPositiveCompareAt = originalPriceBDT !== null
    && originalPriceBDT > salePriceBDT
    && originalPriceBDT > 0;
  return {
    salePriceBDT,
    originalPriceBDT,
    discountPercent,
    isOnSale: hasPositiveCompareAt && discountPercent >= minSaleDiscountPercent,
  };
}